import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { aiReducer } from './store/ai.reducer';
import { AiEffects } from './store/ai.effect';
import { AiService } from './ai.service';
import { AiPanelComponent } from './ai-panel/ai-panel.component';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('ai', aiReducer),
    EffectsModule.forFeature([AiEffects]),
    
  ],
  declarations: [AiPanelComponent],
  exports: [AiPanelComponent],
  providers: [AiService],
})
export class AiModule {}
